/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Typography, message, Icon, Button } from 'antd';
import { subscribe } from 'alfa';
import uuidv4 from 'uuid/v4';
import { withTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';

import DebitsForm from './components/debits-form';
import BatchRepo from '../../repository/batch';
import URL from '../../helpers/url';
import { csvExample } from '../../helpers/constants';
import { validate, csvOptions } from './components/creation-helpers';
import { summaryColumns } from './components/SummaryColumns';

const { Title } = Typography;

class DebitsBatchNew extends Component { // eslint-disable-line fp/no-class
  constructor(props) {
    super(props);
    this.state = {
      id: uuidv4(),
      description: null,
      file: {},
      redirect: false,
    };
  }

    createBatch = async () => {
      const { id, description, file } = this.state;
      const { business, account, t } = this.props;
      try {
        await BatchRepo.createDebits(id, { business, account, description, csv: file });
        this.setState({
          redirect: true,
        });
      } catch (error) {
        console.error('ERROR: createBatch() response: ', error.response);
        message.error(`${t('error.creating_batch')}: ${error.response.data.message}`);
      }
    };

    processBatch = (description, file) => {
      this.setState({
        file,
        description,
      }, () => {
        this.createBatch();
      });
    };

    render() {
      const { t, account } = this.props;

      if (this.state.redirect) {
        return <Redirect to={URL(`/accounts/${account.id}/batches/debits`, this.props)} />;
      }

      return (
        <>
          <Title level={3}>
            {t('create_debits_batch')}
            <Button.Group style={{ float: 'right' }}>
              <Button onClick={() => { window.location = csvExample.debits; }}><Icon type="download" /> {t('batch.download_example')}</Button>
            </Button.Group>
          </Title>
          <DebitsForm
            onSubmit={this.processBatch}
            validate={validate.debits}
            batchOptions={csvOptions.debits}
            summaryColumns={summaryColumns.debits}
          />
        </>
      );
    }
}

DebitsBatchNew.propTypes = {
  account: PropTypes.shape({
    balance: PropTypes.shape({
      available: PropTypes.any,
    }),
    id: PropTypes.any,
    region_id: PropTypes.any,
  }),
  business: PropTypes.shape({
    id: PropTypes.any,
  }),
  t: PropTypes.func,
};

export { DebitsBatchNew };
export default subscribe(withTranslation()(DebitsBatchNew), ['business', 'account']);
